export class LabIdManager {
  public static labId: string;

  constructor() {}
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/labIdManager.ts